import React from 'react';
import { Link } from 'react-router';
import DataTable from 'components/data-table';
import { connect } from 'react-redux';
import { Reception } from 'api';
import moment from 'moment';
import { header } from 'constants/table';
import { msg } from 'constants/message';
import { Toastr } from 'modules/toastr';
import { CheckPermission } from 'modules/login/CheckPermission';
import { FormTimKiemNangCao } from 'modules/reception/form-timkiem';
import {FormSort} from 'modules/reception/form-sort';
import { RowItemReception } from 'modules/reception/datatable/list';
import {MasterLayout} from 'layout';

class ReceptionPage extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      data: this.props.data,
      dataLoaiDonThu: [],
      dataHuongXuLy: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      sortBy: 'ngayTiepDan,desc',
      advanceSearch: false,
      searchSubmit: false,
      startDateValid: true,
      endDateValid: true,
      search: false,
      tableLoading: false,
      searchLoading: false,
      searchKey: '',
      receptionType:'',
      handleRedirect: '',
      startDate: '',
      endDate: ''
    };
  }

  componentDidMount() {
    let data = localStorage.getItem('tcdtxData') ? JSON.parse(localStorage.getItem('tcdtxData')) : {};
    this.state.advanceSearch = data.advanceSearch || false;
    this.state.pageData.number = data.page || 0;
    this.state.pageData.size = data.size || 10;
    this.state.searchKey = data.tuKhoa || '';
    if (this.state.advanceSearch) {
      this.state.receptionType = data.phanLoaiDon || '';
      this.state.handleRedirect = data.huongXuLy || '';
      this.state.startDate = data.startDate ? new Date(data.startDate) : '';
      this.state.endDate = data.endDate ? new Date(data.endDate) : '';
    }
    this.setState({...this.state});
    this.getListData();
   
  }

  openSearchForm() {
    this.setState({advanceSearch: true});
    let data = localStorage.getItem('tcdtxData') ? JSON.parse(localStorage.getItem('tcdtxData')) : {};
    data.advanceSearch = true;
    localStorage.setItem('tcdtxData', JSON.stringify(data));
  }

  closeSearchForm() {
    this.setState({advanceSearch: false});
    let data = localStorage.getItem('tcdtxData') ? JSON.parse(localStorage.getItem('tcdtxData')) : {};
    data.advanceSearch = false;
    localStorage.setItem('tcdtxData', JSON.stringify(data));
  }

  handleDelete(sID) {
    Reception.actions.deleteTiepCongDan.request({
      id: sID
    }).then(res => {
      Toastr(msg.dTCDTX, 'success');
      this.props.dispatch({
        type: 'REFRESH_MENU',
        value: true
      });
      this.props.dispatch({
        type: 'DELETE_ITEM_DATALIST',
        key: 'listTCDTX',
        idKey: 'soTiepCongDanId',
        id: sID
      });
      this.getListData();
    }).catch(err => {
      let Data = err.response && err.response.data && err.response.data.errors ? err.response.data.errors : [];
      Data.map(item => {
        Toastr(item.description, 'error');
      })
    });
  }

  handleChange(name, e) {
    this.setState({
      [e.target.name]: e.target.value
    });
    if (name === 'sortBy') {
      this.handleSort(e.target.value);
    }
  }

  handleSort(sortBy) {
    let params = {
      loaiTiepCongDan: 'THUONG_XUYEN',
      page: this.state.pageData.number,
      size: this.state.pageData.size,
      sort: sortBy
    };
    this.setState({
      searching: true,
      tableLoading: true,
      searchLoading: true
    });

    if (this.state.searchKey) {
      params.tuKhoa = this.state.searchKey;
    }
    if (this.state.advanceSearch) {
      if (this.state.receptionType) {
        params.phanLoaiDon = this.state.receptionType;
      }

      if (this.state.handleRedirect) {
        params.huongXuLy = this.state.handleRedirect;
      }

      if (this.state.startDate) {
        params.tuNgay = moment(this.state.startDate, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }

      if (this.state.endDate) {
        params.denNgay = moment(this.state.endDate, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }
    }
    localStorage.setItem('tcdtxData', JSON.stringify({...params, advanceSearch: this.state.advanceSearch}));
    Reception.actions.getTiepCongDan.request(null, params).then(res => {
      let Data = [];
      if (res.data._embedded) {
        Data = res.data._embedded.soTiepCongDans;
        this.state.pageData = res.data.page;
      } else {
        this.state.pageData = {
          number: 0,
          size: 10,
          totalElements: 0
        };
      }
      this.setState({
        tableLoading: false,
        searchLoading: false,
        searching: false,
        search: false
      });
      this.props.dispatch({type: 'UPDATE_DATALIST', key: 'listTCDTX', data: Data})
      if (this.refs.tcdTX) {
        this.setState({...this.state});
      }
    }).catch(err => {
      this.setState({
        tableLoading: false,
        searchLoading: false,
        searching: false,
        search: false
      });
      if (this.refs.tcdTX) {
        this.setState({...this.state});
      }
    });
  }

  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.getListData();
  }

  handleChangePageSize(size) {
    this.state.pageData.size = size;
    this.state.pageData.number = 0;
    this.getListData();
  }

  handleSearch(searchData, e) {
    // Dung ung dung neu ngay nhap khong hop le
    if ([searchData.startDate, searchData.endDate].indexOf('INVALID') != -1) {
      return;
    }
    this.state.search = true;
    let newData = {
      ...this.state,
      ...searchData
    };
    this.state = newData;
    this.state.pageData = {
      number: 0,
      size: 10,
      totalElements: 0
    };
    this.setState({...this.state});

    this.getListData();
  }

  getListData() {

    let params = {
      loaiTiepCongDan: 'THUONG_XUYEN',
      page: this.state.pageData.number,
      size: this.state.pageData.size,
      sort: this.state.sortBy
    }

    this.setState({
      searching: true,
      tableLoading: true,
      searchLoading: true
    });

    if (this.state.searchKey) {
      params.tuKhoa = this.state.searchKey;
    }
    if (this.state.advanceSearch) {
      if (this.state.receptionType) {
        params.phanLoaiDon = this.state.receptionType;
      }

      if (this.state.handleRedirect) {
        params.huongXuLy = this.state.handleRedirect;
      }

      if (this.state.startDate) {
        params.tuNgay = moment(this.state.startDate, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }

      if (this.state.endDate) {
        params.denNgay = moment(this.state.endDate, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }
    }
    localStorage.setItem('tcdtxData', JSON.stringify({...params, advanceSearch: this.state.advanceSearch}));
    Reception.actions.getTiepCongDan.request(null, params).then(res => {
      let Data = [];
      if (res.data._embedded) {
        Data = res.data._embedded.soTiepCongDans;
        this.state.pageData = res.data.page;
      } else {
        this.state.pageData = {
          number: 0,
          size: 10,
          totalElements: 0
        };
      }
      this.state.tableLoading = false;
      this.state.searchLoading = false;
      this.state.searching = false;
      this.state.search = false;
      this.props.dispatch({type: 'UPDATE_DATALIST', key: 'listTCDTX', data: Data})
      if (this.refs.tcdTX) {
        this.setState({...this.state});
      }
    }).catch(err => {
      this.state.tableLoading = false;
      this.state.searchLoading = false;
      this.state.searching = false;
      this.state.search = false;
      if (this.refs.tcdTX) {
        this.setState({...this.state});
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.data != this.props.data) {
      this.state.data = nextProps.data;
      this.setState({...this.state})
    }
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container" ref="tcdTX">
          <div className="top-content">
            <div className="left-content">
              <p className="title-18"><i className="tt tt-reception"></i>Sổ tiếp công dân thường xuyên</p>
            </div>
            <div className="right-content">
              { CheckPermission('SOTIEPCONGDAN_THEM') ?
                <Link className="btn-green" to="/tiep-cong-dan/thuong-xuyen/them-moi"><i className="tt tt-addfile"></i>Thêm mới</Link>
                : null }
            </div>
          </div>
          <div className="bottom-content">
            <div className={ this.state.advanceSearch ? 'search-container super-search' : 'search-container' }>
              <FormTimKiemNangCao advanceSearch={this.state.advanceSearch} onCancel={ this.closeSearchForm.bind(this) } handleSearch={ this.handleSearch.bind(this) } disabled={ this.state.searching } search={ this.state.search } />
              <Link className="rearch-text" onClick={ this.openSearchForm.bind(this) }><i className="tt tt-super-search"></i>Tìm kiếm nâng cao</Link>
            </div>
            <FormSort
              type='tiepCongDanThuongXuyen'
              pageDetail={this.state.pageData}
              selectedValue={this.state.sortBy}
              onChange={ this.handleChange.bind(this, 'sortBy') }
            />
            <DataTable header={ header.listTCD } dataList={ this.state.data } exporttext="Xuất Sổ tiếp công dân" pageData={ this.state.pageData } parent={ this } search={ this.state.advanceSearch }
              tableLoading={ this.state.tableLoading } sortBy={ this.state.sortBy }>
              <RowItemReception/>
            </DataTable>
          </div>
        </div>
      </MasterLayout>
      );
  }
}

ReceptionPage.defaultProps = {
  data: []
}

function bindStateToProps(state) {
  return {
    data: state.dataList.data.listTCDTX
  };
}

export default connect(bindStateToProps)(ReceptionPage);



// WEBPACK FOOTER //
// ./src/components/modules/reception/list-reception/ListReception.jsx